import PagePublic2Col from '../../components/Page/PagePublic2Col';
import { IMAGE_RUN } from '../../constants';
import RegisterCard from './RegisterCard';
//import OnboardingSteps from '../../ProtectedPages/MainWelcome/Onboarding/Steps/OnboardingSteps'

export default function RegisterPage2Col() {

    return (
   
<PagePublic2Col

    leftsideimage={IMAGE_RUN}
    brandtext="Preventive Health Intelligence"
    headline=""
    formcomp={<RegisterCard />}

  />

  )
}

